export default {
    drawTitleModel:drawTitleModel
}


/**
 * 拼接title模块
 *
 * @param  {Object} data
 * 详见pageMock.js文件中"modelType":"link_3"对象
 *
 * @return {String}
 * 拼接后的dom
 */
function drawTitleModel(data,moduleIndex) {
    var linkUrl = data.linkUrl ? data.linkUrl.trim() : ''
    var guide = data.guide ? data.guide.trim() : ''
    return `<a class="model-title clickreport" ${linkUrl ? `href="${linkUrl}&tag=${data.tag}" data-tag="${data.tag}-more"` : ''} data-clickLog="${`${moduleIndex}___more`}">
				${data.iconUrl ? `<img src="${data.iconUrl}" />` : ''}
				<p>${data.title}</p>
				${guide ? `<span>${guide}<i class="icon-greaterLabel"></i></span>` : ''}
			</a>`
}